export default {
    orders: {},
    typeView: 'All',
};
